export default __webpack_public_path__ + "static/reviews-humans-d5c29b8acf7ea27bc412865043e1ba22.svg";